import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { services } from '../data/mockData';
import { Database, Cloud, Shield, Users, ArrowRight } from 'lucide-react';

const iconMap = {
  Database: Database,
  Cloud: Cloud,
  Shield: Shield,
  Users: Users,
};

const ServicesPage = () => {
  const detailedServices = [
    {
      ...services[0],
      fullDescription: 'Our Data & AI solutions help organizations harness the power of their data through advanced analytics, machine learning, and artificial intelligence. We transform raw data into actionable insights that drive strategic decision-making.',
      features: ['Predictive Analytics', 'Machine Learning Models', 'Data Visualization', 'AI Integration'],
    },
    {
      ...services[1],
      fullDescription: 'We guide organizations through their cloud journey, from initial assessment to full migration and optimization. Our modernization services ensure your infrastructure is agile, scalable, and cost-effective.',
      features: ['Cloud Migration', 'Infrastructure Modernization', 'DevOps Implementation', 'Cost Optimization'],
    },
    {
      ...services[2],
      fullDescription: 'Our comprehensive security solutions protect your digital assets from evolving threats. We implement robust security frameworks that ensure compliance and safeguard your business continuity.',
      features: ['Cybersecurity Assessment', 'Threat Detection', 'Compliance Management', 'Security Operations'],
    },
    {
      ...services[3],
      fullDescription: 'Our PMO Support services provide expert project management capabilities to ensure your initiatives are delivered on time, within budget, and to the highest quality standards.',
      features: ['Project Planning', 'Resource Management', 'Risk Mitigation', 'Performance Tracking'],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero Section */}
      <section className="pt-32 pb-20 bg-gradient-to-br from-blue-100 via-blue-50 to-orange-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-12 h-0.5 bg-orange-500" />
              <span className="text-gray-600 font-medium tracking-wide">Our Services</span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-slate-900 mb-6">
              What We Do
            </h1>
            <p className="text-gray-700 text-lg leading-relaxed">
              We deliver end-to-end technology solutions that transform your business and drive growth. Our expertise spans across Data & AI, Cloud, Security, and Project Management.
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="space-y-16">
            {detailedServices.map((service, index) => {
              const Icon = iconMap[service.icon];
              const isEven = index % 2 === 0;
              
              return (
                <div
                  key={service.id}
                  className={`grid lg:grid-cols-2 gap-12 items-center ${isEven ? '' : 'lg:flex-row-reverse'}`}
                >
                  <div className={isEven ? '' : 'lg:order-2'}>
                    <div className="w-16 h-16 bg-orange-100 rounded-2xl flex items-center justify-center mb-6">
                      <Icon className="w-8 h-8 text-orange-500" />
                    </div>
                    <h2 className="text-3xl font-bold text-slate-900 mb-4">{service.name}</h2>
                    <p className="text-gray-600 text-lg leading-relaxed mb-6">
                      {service.fullDescription}
                    </p>
                    <ul className="space-y-3">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-center text-gray-700">
                          <ArrowRight className="w-5 h-5 text-orange-500 mr-3" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className={`${isEven ? 'lg:order-2' : ''}`}>
                    <div className="relative h-80 bg-gradient-to-br from-slate-100 to-slate-200 rounded-3xl overflow-hidden">
                      <div className="absolute inset-0 bg-gradient-to-br from-orange-500/10 to-blue-500/10" />
                      <div className="absolute inset-0 flex items-center justify-center">
                        <Icon className="w-32 h-32 text-slate-300" />
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default ServicesPage;
